import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import {
  SmallPurpleCard,
  SmallRedCard,
  MediumRedCard,
  MediumPurpleCard,
  LargeCard,
  SmallTitleSkeleton,
  SmallDescriptionSkeleton,
  MediumTitleSkeleton,
  MediumDescriptionSkeleton,
  LargeTitleSkeleton,
  LargeDescriptionSkeleton,
} from "./styled";

const FeaturedCarouselColoredPromotions: FC = () => {
  return (
    <SpaceBetweenCenter gap={2} sx={{ marginTop: "16px" }}>
      <SmallPurpleCard>
        <SmallTitleSkeleton />
        <SmallDescriptionSkeleton />
      </SmallPurpleCard>
      <MediumRedCard>
        <MediumTitleSkeleton />
        <MediumDescriptionSkeleton />
      </MediumRedCard>
      <LargeCard>
        <LargeTitleSkeleton />
        <LargeDescriptionSkeleton />
      </LargeCard>
      <MediumPurpleCard>
        <MediumTitleSkeleton />
        <MediumDescriptionSkeleton />
      </MediumPurpleCard>
      <SmallRedCard>
        <SmallTitleSkeleton />
        <SmallDescriptionSkeleton />
      </SmallRedCard>
    </SpaceBetweenCenter>
  );
};

export default FeaturedCarouselColoredPromotions;
